import React from 'react';
import { motion } from 'framer-motion';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  children: React.ReactNode;
  className?: string;
  fullWidth?: boolean;
}
export function Button({
  children,
  className = '',
  fullWidth = false,
  ...props
}: ButtonProps) {
  return <motion.button whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.98
  }} className={`
        bg-magenta-500 hover:bg-magenta-600 text-white font-bold py-3 px-5 sm:py-4 sm:px-8 rounded-xl
        shadow-[0_0_20px_rgba(233,30,140,0.4)] hover:shadow-[0_0_30px_rgba(233,30,140,0.6)]
        transition-all duration-300 uppercase tracking-wide text-sm sm:text-lg md:text-xl
        ${fullWidth ? 'w-full' : ''}
        ${className}
      `} {...props} data-id="element-310">
      {children}
    </motion.button>;
}